export default "__VITE_ASSET__CRDeRbgJ__"